import 'regenerator-runtime/runtime';
import PixelConfigurationHttpClient from '../clients/pixelConfigurationHttpClient';
import PixelConfigurationURLClient from '../clients/pixelConfigurationURLClient';
import logger from '../common/safe-log';
import EncryptionService from '../services/encryptionService';


const ENABLE_GU_PIX = false;

const getBrandName = () => {
  try {
    const domainParts = window.location.host.split('.');
    const nakedDomain = domainParts[domainParts.length - 2];
    const brandName = nakedDomain.split('-')?.[1] || null;
    return brandName;
  } catch (e) {
    return null;
  }
}

const validateGetPixelConfigFromBrandNameAndAffIdAndOIdParams = (brandName, affiliateId, offerId) => {
  const validationResult = [true, []]
  const pushFieldFailed = (argName, message) => {
    validationResult[0] = false;
    validationResult[1].push({ args: `${argName}`, message })
  }

  if (!brandName) pushFieldFailed('brandName', 'Brand name is required')
  if (!affiliateId) pushFieldFailed('affiliateId', 'Affiliate Id is required')
  if (!offerId) pushFieldFailed('offerId', 'Offer Id is required')

  return validationResult
}

const PixelConfigurationService = {
  getPixelConfigurationForCurrentPageAsync: async () => {
    try {
      let pixelConfig = null;

      if (ENABLE_GU_PIX) {
        pixelConfig = PixelConfigurationURLClient.getPixelConfigFromUrl();
      }

      if (!pixelConfig) {
        const oid = window?.gu_qs?.oid;
        const affId = window?.gu_qs?.aff_id;
        if (!oid || !affId) {
          logger.info('No affid or oid');
          return null;
        } else {
          const brandName = getBrandName();
          const requestPayload = {
            offerId: oid,
            affiliateId: affId
          };

          if (brandName) {
            requestPayload.brandName = brandName;
          }

          const encryptedPayload = EncryptionService.encrypt(JSON.stringify(requestPayload));
          const response = await PixelConfigurationHttpClient.getPixelConfigurationAsync(encryptedPayload);

          if (response?.data?.result) {
            let decryptedConfig = EncryptionService.decrypt(response.data.result);
            if (decryptedConfig) {
              decryptedConfig = JSON.parse(decryptedConfig);
              pixelConfig = decryptedConfig?.pixelConfigs;
            }
          }
        }
      }
      return pixelConfig;

    } catch (e) {
      return null;
    }
  },
  async getPixelConfigFromBrandNameAndAffIdAndOId(brandNameParam = 'default', affiliateId, offerId) {
    try {
      const brandName = brandNameParam || 'default'
      const [isValid, validationErrors] = validateGetPixelConfigFromBrandNameAndAffIdAndOIdParams(brandName, affiliateId, offerId)

      if (!isValid) {
        logger.warn('Cannot get Pixel configs', { validationErrors, args: { brandName, affiliateId, offerId } });
        return null;
      }

      const requestPayload = {
        brandName,
        offerId,
        affiliateId
      }

      const encryptedPayload = EncryptionService.encrypt(JSON.stringify(requestPayload));
      const response = await PixelConfigurationHttpClient.getPixelConfigurationAsync(encryptedPayload);

      if (!response?.data?.result) {
        logger.info('No pixel configs found for ', { brandName, affiliateId, offerId });
        return null;
      }

      let decryptedConfig = EncryptionService.decrypt(response.data.result);

      if (!decryptedConfig) {
        logger.warn('No pixel configs found for ', { brandName, affiliateId, offerId });
        return null;
      }

      decryptedConfig = JSON.parse(decryptedConfig);
      return decryptedConfig?.pixelConfigs;
    } catch (error) {
      console.error('Error occurred in getPixelConfigFromBrandNameAndAffIdAndOId()', error)
      return null;
    }
  },
};

export default PixelConfigurationService;